import { render } from "./damagedstock.vue?vue&type=template&id=7f3f251c&scoped=true"
import script from "./damagedstock.vue?vue&type=script&lang=js"
export * from "./damagedstock.vue?vue&type=script&lang=js"

import "./damagedstock.vue?vue&type=style&index=0&id=7f3f251c&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3f251c"]])

export default __exports__